export const developersConstants = {
  LOGHISTORY_REQUEST: 'LOGHISTORY_REQUEST',
  LOGHISTORY_SUCCESS: 'LOGHISTORY_SUCCESS',
  LOGHISTORY_FAILURE: 'LOGHISTORY_FAILURE',
};
